import React from 'react';
import PropTypes from 'prop-types';
import Icon from '@hydra/common/components/Icon';
import Modal from '@material-ui/core/Modal';

import { makeStyles } from '@material-ui/core/styles';

LoadingOverlay.propTypes = {
  isLoading: PropTypes.bool,
  overlay: PropTypes.bool
};

LoadingOverlay.defaultProps = {
  overlay: true
};

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none',
    outline: 'none'
  },
  icon: {
    pointerEvents: 'none',
    outline: 'none'
  }
}));

export default function LoadingOverlay (props) {
  const { isLoading } = props;

  const classes = useStyles();

  return (
    <Modal
      className={classes.root} open={isLoading} disableBackdropClick BackdropProps={{
        invisible: false
      }}
    >
      <div className={classes.icon}>
        <Icon type='loader' size='lg' color='white' />
      </div>
    </Modal>
  );
}
